'use strict';

/**
 * message
 */
export const message = (() => {

    /**
     * init
     */
    const init = () => {
        adjust();

        $(window).on('load', function () {
            adjust();
        });
    };

    const adjust = () => {
        if ($('#home').length > 0) {
            var pos = 0;

            window.addEventListener("message", function (e) {
                pos = e.data;
                $('.js-message').height(pos);
                $('.js-message-iframe').height(pos);

                if (pos > 180) {
                    $('.js-message').addClass('is-myfund');
                } else {
                    $('.js-message').removeClass('is-myfund');
                }
            });
        }
    };

    // public
    return {
        init: init
    };
})();
